export default __webpack_public_path__ + "5477d1575d34d0494ed5245b549360b8.png";